<app-banner>
    <form [formGroup]="resetForm" class="public-page-forms" (ngSubmit)="onSubmit()">
        <h1 class="form-title text-primary" i18n="@@resetPassword.forgotPassword">Wachtwoord vergeten</h1>
        <div class="input-container">
            <label for="inputEmail" i18n="@@email">E-mailadres</label>
            <input id="inputEmail" type="email" formControlName="email" class="text-input" required autocomplete="email" />
        </div>
        @if (success) {
            <div class="text-success" i18n="@@resetPassword.newPasswordMessage">Nieuw wachtwoord werd aangevraagd. Check je email!</div>
        }
        <div class="button-row">
            <button type="submit" class="button-primary huge w-full" [disabled]="!resetForm.valid || busy || success">
                <ng-container [ngTemplateOutlet]="!busy ? defaultMessage : loading"></ng-container>
            </button>
        </div>
        <a class="primary-link font-bold" routerLink="/login" i18n="@@public.backToLogin">Terug naar loginpagina</a>
    </form>
</app-banner>

<ng-template #defaultMessage><span i18n="@@resetPassword.newPassword">Nieuw wachtwoord aanvragen</span></ng-template>
<ng-template #loading> <fa-icon class="mr-0" [icon]="loadingIcon" [animation]="'spin'"></fa-icon></ng-template>
